<svg
  id="icon"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 32 32"
  width="22"
  height="22"
  fill="none"
>
  <defs>
    <style>
      .cls-1 {
        fill: none;
      }
    </style>
  </defs>
  <title>erase</title>
  <rect x="7" y="27" width="23" height="2" fill="currentColor" />
  <path
    fill="currentColor"
    d="M27.38,10.51,19.45,2.59a2,2,0,0,0-2.83,0l-14,14a2,2,0,0,0,0,2.83L7.13,24h9.59L27.38,13.34A2,2,0,0,0,27.38,10.51ZM15.89,22H8L4,18l6.31-6.31,7.93,7.92Zm3.76-3.76-7.92-7.93L18,4,26,11.93Z"
    transform="translate(0 0)"
  />
  <rect
    id="_Transparent_Rectangle_"
    fill="currentColor"
    data-name="&lt;Transparent Rectangle&gt;"
    class="cls-1"
    width="30"
    height="30"
  /></svg
>
